// 20240216 https://dev-api.cloudw2p.com/api/v1/menu/getmenutree
export default {
  state: {
    navBarList1: [],
    navBarList2: [],
    navBarList3: []
  },
  actions: {
    getNavBar ({ commit }) {
      let API_PATH = process.env.API
      fetch(`${API_PATH}menu/getmenutree_full`, { method: 'get' })
        .then((res) => {
          return res.json()
        })
        .then((result) => {
          let navBarList1 = result.data
          let navBarList2 = []
          let navBarList3 = []
          for (let i = 0; i < navBarList1.length; i++) {
            for (let j = 0; j < navBarList1[i].subMenus.length; j++) {
              navBarList2.push(navBarList1[i].subMenus[j])
            }
          }
          for (let i = 0; i < navBarList2.length; i++) {
            for (let j = 0; j < navBarList2[i].subMenus.length; j++) {
              navBarList3.push(navBarList2[i].subMenus[j])
            }
          }

          // console.log(navBarList1)
          // console.log(navBarList2)
          // console.log(navBarList3)

          commit('navbarDetail', {
            navBarList1,
            navBarList2,
            navBarList3
          })
        })
    }
  },
  mutations: {
    navbarDetail (state, { navBarList1, navBarList2, navBarList3 }) {
      state.navBarList1 = navBarList1
      state.navBarList2 = navBarList2
      state.navBarList3 = navBarList3
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/navbarNew.js